import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateVenueDetailsBody, IUpdateVenueDetailsResponse, IVenueDetailsResponse } from '.';

export const updateVenueDetails = async (
  venueId: string,
  requestBody: IUpdateVenueDetailsBody,
): Promise<IVenueDetailsResponse> => {
  try {
    const response = await fetch(`${API_URL}/venues/${venueId}`, {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: IUpdateVenueDetailsResponse = await response.json();
    return data[0];
  } catch (e) {
    throw new Error('Something went wrong whilst updating venue details');
  }
};
